var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { SelectedNodesModel } from '../models/selected-nodes-model.interface';
let SelectedNodesServiceImpl = class SelectedNodesServiceImpl {
    constructor(_selectedNodesModel) {
        this._selectedNodesModel = _selectedNodesModel;
    }
    getSelectedNodeIds() {
        return this._selectedNodesModel.selectedNodeIds;
    }
    updateSelectedNodeIds(selectedIds) {
        this._selectedNodesModel.updateSelectedNodeIds(selectedIds);
    }
    subscribeSelectedNodeIds(callback) {
        return this._selectedNodesModel.onStatesChange(callback);
    }
};
SelectedNodesServiceImpl = __decorate([
    injectable(),
    __param(0, inject(SelectedNodesModel)),
    __metadata("design:paramtypes", [typeof (_a = typeof SelectedNodesModel !== "undefined" && SelectedNodesModel) === "function" ? _a : Object])
], SelectedNodesServiceImpl);
export { SelectedNodesServiceImpl };
